<template>
  <div class="overlay-timeout" v-if="this.isVisible">
    <div class="ui-alert-content">
      <label class="ui-label alert-title-label">Ошибка</label>
      <label class="ui-label alert-message-label">
        Время на покупку истекло. Вернитесь к выбору мест если хотите продолжить
        покупку.
      </label>
      <div @click="reloadApp" class="ui-btn alert-ok-btn">
        <span class="btn-icon"></span>
        <span class="btn-label">Вернуться к выбору мест</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import urlQueryParts from '../helpers/urlQueryParts';

export default {
  name: 'Timeout',

  data() {
    return {
      timer: null,
      isVisible: false,
    };
  },

  computed: {
    ...mapState(['user', 'errors', 'movie', 'barAfterUmounted']),
    sessionEndAt() {
      return this.user.sessionEndAt;
    },
  },

  watch: {
    sessionEndAt(newSessionEndAt) {
      if (newSessionEndAt && !this.timer) {
        // get difference between sessionEndTime and the current time
        let diff = new Date(newSessionEndAt).getTime() - Date.now();

        this.timer = window.setTimeout(() => {
          this.isVisible = true;
        }, diff);
      } else {
        window.clearTimeout(this.timer);
        this.timer = null;
        this.isVisible = false;
      }
    },
  },

  methods: {
    reloadApp() {
      if (this.movie.Id)
        this.$router.push(
          `/${this.$route.params.theatreId}/${
            this.$route.params.session
          }/hall${urlQueryParts(this.$route.query)}`,
        );
      else {
        if (this.barAfterUmounted) {
          const { selectCity, selectTheatre, productFolder, productId } =
            this.barAfterUmounted;
          if (selectCity || selectTheatre || productFolder || productId) {
            let query = {};
            if (selectCity) query.cityId = selectCity;
            if (selectTheatre) query.theatreId = selectTheatre;
            if (productFolder) query.productFolder = productFolder;
            if (productId) query.productId = productId;
            window.location.href = `/bar${urlQueryParts(query)}`;

            return;
          }
        }

        if (this.$route.params.theatreId) {
          window.location.href = `/bar${urlQueryParts(this.$route.query)}`;

          return;
        }
      }
      //this.$store.dispatch('goBackTimeout');
      //this.$router.push(`/${this.$route.params.theatreId}/${this.$route.params.session}/hall${urlQueryParts(this.$route.query)}`);
    },
  },
};
</script>

<style>
.overlay-timeout {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.75);
  font-size: 24px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #ffffff;
  z-index: 100;
}

.ui-alert-content {
  width: 335px;
  background: transparent;
  color: #ffffff;
}

.alert-title-label {
  font-family: HelveticaNeue, Helvetica Neue, HelveticaNeueRoman,
    HelveticaNeue-Roman, Helvetica Neue Roman, TeXGyreHerosRegular,
    HelveticaNeueLocal, Helvetica, Tahoma, Geneva, Arial, sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.024em;
  color: #fff;
  display: block;
  padding: 20px 10px 3px;
  text-align: center;
}

.alert-message-label {
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  display: block;
  text-align: center;
  padding: 0 10px 17px;
  text-align: center;
  font-weight: 300;
}

.alert-ok-btn {
  height: 56px;
  border: none;
  border-radius: 4px;
  background-color: #0d76ff;
  font-family: HelveticaNeueMedium, HelveticaNeue-Medium, Helvetica Neue Medium,
    HelveticaNeue, Helvetica Neue, TeXGyreHerosRegular, HelveticaNeueMediumLocal,
    Helvetica, Tahoma, Geneva, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

@media only screen and (max-width: 320px) {
  .ui-alert-content {
    width: calc(100% - 35px);
  }
}
</style>
